export default "__VITE_ASSET__BHg86aOp__"